import Grid from "components/Grid";
import ProfileStrengthBar from "components/ProfileStrengthBar";
import Text from "components/Text";
import { FC } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { FiCheck } from "react-icons/fi";
import { colors } from "theme/colors";
import {
    ProfileStrengthTitle,
    ProfileStrengthWrapper,
    Step,
    Steps,
    SubTitle,
} from "./ProfileStrength.styled";
import { useProfileStrength } from "./useProfileStrength";

export const ProfileStrength: FC = () => {
    const { data } = useProfileStrength();

    return (
        <ProfileStrengthWrapper>
            <ProfileStrengthTitle variant="body2">
                PROFILE STRENGTH
            </ProfileStrengthTitle>
            <SubTitle variant="label">
                Your profile is now active and can be found by agency
            </SubTitle>
            <ProfileStrengthBar
                minWidth="70%"
                progress={data?.total_percentage || 0}
            />
            <Grid row={true} marginTop={1}>
                <Text
                    variant="label"
                    fontWeight="600"
                    fontSize="13px"
                    color={colors.grey.primary}
                >
                    Steps to complete
                </Text>
            </Grid>
            <Steps>
                <Step isComplete={data?.profile_status.personal_info}>
                    {data?.profile_status.personal_info ? (
                        <FiCheck />
                    ) : (
                        <AiOutlinePlusCircle />
                    )}
                    <Text variant="label">Personal Information</Text>
                </Step>
                <Step isComplete={data?.profile_status.contact_detail}>
                    {data?.profile_status.contact_detail ? (
                        <FiCheck />
                    ) : (
                        <AiOutlinePlusCircle />
                    )}
                    <Text variant="label">Contact Details</Text>
                </Step>
                <Step isComplete={data?.profile_status.other_interest}>
                    {data?.profile_status.other_interest ? (
                        <FiCheck />
                    ) : (
                        <AiOutlinePlusCircle />
                    )}
                    <Text variant="label">Other Interests</Text>
                </Step>
                <Step isComplete={data?.profile_status.physical_detail}>
                    {data?.profile_status.physical_detail ? (
                        <FiCheck />
                    ) : (
                        <AiOutlinePlusCircle />
                    )}
                    <Text variant="label">Physical Details</Text>
                </Step>
                <Step isComplete={data?.profile_status.user_location}>
                    {data?.profile_status.user_location ? (
                        <FiCheck />
                    ) : (
                        <AiOutlinePlusCircle />
                    )}
                    <Text variant="label">Locations</Text>
                </Step>
                <Step isComplete={data?.profile_status.experiences}>
                    {data?.profile_status.experiences ? (
                        <FiCheck />
                    ) : (
                        <AiOutlinePlusCircle />
                    )}
                    <Text variant="label">Experiences</Text>
                </Step>
                <Step isComplete={data?.profile_status.social_links}>
                    {data?.profile_status.social_links ? (
                        <FiCheck />
                    ) : (
                        <AiOutlinePlusCircle />
                    )}
                    <Text variant="label">Social Links</Text>
                </Step>
                <Step isComplete={data?.profile_status.user_languages}>
                    {data?.profile_status.user_languages ? (
                        <FiCheck />
                    ) : (
                        <AiOutlinePlusCircle />
                    )}
                    <Text variant="label">Languages</Text>
                </Step>
                <Step isComplete={data?.profile_status.user_images}>
                    {data?.profile_status.user_images ? (
                        <FiCheck />
                    ) : (
                        <AiOutlinePlusCircle />
                    )}
                    <Text variant="label">Images</Text>
                </Step>
            </Steps>
        </ProfileStrengthWrapper>
    );
};
